module.exports = __webpack_public_path__ + "assets/img/11_475_big.0fec3d01.jpg";